<template>
  <basic-dialog
    v-model="dialog"
    :action-buttons="actionButtons"
    :title="$t('translations.select_translation')"
  >
    <v-card-text class="pt-4">
      <v-combobox v-model="selectedTranslation" :items="translations" :label="$tc('translations.title',1)"
                  item-text="translation" item-value="tid">

      </v-combobox>
    </v-card-text>
    <v-card-text>
      <translation-edit-form ref="translationEditForm" v-model="selectedTranslation"></translation-edit-form>
    </v-card-text>
  </basic-dialog>

</template>

<script>
import BasicDialog from "@/components/BasicDialog";
import TranslationService from "@/service/translation.service";
import TranslationEditForm from "@/components/Translations/TranslationEditForm";
import translationApi from "@/api/translation";

export default {
  name: "SelectTranslationDialog",
  components: {TranslationEditForm, BasicDialog},
  data() {
    return {
      dialog: false,
      selectedTranslation: null,
      field: null,
      loading: false,
      actionButtons: {
        close: {
          click: () => {
            this.dialog = false;
          }
        },
        select: {
          click: this.selectTranslation,
          color: 'primary',
          icon: 'mdi mdi-check'
        }

      }
    }
  },
  props: {
    prefix: {
      type: String,
      default: '',
    }
  },
  computed: {
    translations() {
      //const translations = TranslationService.ct
      const translations = TranslationService.atArray;
      translations.map(translation => {
        let translationSearchString = [translation.tid];
        this.languages.forEach(language => {
          translationSearchString.push(translation[language]);
        });

        translation.searchString = translationSearchString.filter(Boolean).join(' ');
        return translation;
      });
      return translations.filter(t => t.tid.startsWith(this.prefix + "."));
    },

    languages() {
      return TranslationService.languages;
    },

  },
  methods: {
    async selectTranslation() {
      if (this.$refs.translationEditForm.dirty) {
        if (!await this.save()) {
          return;
        }
      }
      this.$emit("selected", this.selectedTranslation, this.field);
      this.dialog = false;
    },
    open(field, currentValue) {
      if (field && currentValue) {
        console.log("currentValue", currentValue);
        //this.selectedTranslation = TranslationService.t(currentValue);
        this.selectedTranslation = this.translations.find(t => t.tid === currentValue)
      } else {
        this.selectedTranslation = null;
      }
      this.field = field || null;
      this.dialog = true;
    },
    async save() {

      if (!this.$refs.translationEditForm.$refs.form.validate()) return false;
      this.loading = true;
      try {
        const translations = [];
        this.languages.forEach(language => {
          translations.push({
            language,
            tid: this.selectedTranslation.tid,
            translation: this.selectedTranslation[language]
          });
        });
        await translationApi.saveTranslations(translations);
        await TranslationService.getTranslations();

      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_translation_save_failed'));
        console.error(e);
        this.loading = false;
        return false;
      }
      this.loading = false;
      return true;
    }
  }
}
</script>

<style scoped>

</style>
